
/**
 * Post-hoz formdata előállítása global method
 *
 * @param object
 * @returns {FormData}
 */
export function constructDataForPost(object) {
  const formData = new FormData()
  for (const key in object) {
    formData.append(key, object[key])
  }
  return formData
}
